<template>
  <div id="contact" class="page-slide">
    <div class="contact-form">
      <h2 v-html="lang.sentences.contactUs" />
      <form @submit.prevent="handleSubmit" @reset="handleReset">
        <div class="container">
          <InputText
            v-model="form.fname"
            name="fname"
            :label="lang.firstName"
            :validate="`${lang.sentences.pleaseWrite} ${lang.firstName}`"
            pattern="[a-zA-Z- àâäèéêëîïôœùûüÿçÀÂÄÈÉÊËÎÏÔŒÙÛÜŸÇ]{1,32}"
            class="input small"
          />
          <InputText
            v-model="form.lname"
            name="lname"
            :label="lang.lastName"
            :validate="`${lang.sentences.pleaseWrite} ${lang.lastName}`"
            pattern="[a-zA-Z- àâäèéêëîïôœùûüÿçÀÂÄÈÉÊËÎÏÔŒÙÛÜŸÇ]{1,32}"
            class="input small"
          />
          <InputText
            v-model="form.email"
            name="email"
            type="email"
            :label="lang.email"
            :validate="`${lang.sentences.pleaseWrite} ${lang.email}`"
            pattern="[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,5}"
            class="input large"
          />
          <InputTextarea
            v-model="form.message"
            name="message"
            :label="lang.message"
            height="80px"
            class="input large"
          />
        </div>
        <ButtonLayout
          button="ButtonFlat"
          align="right"
          :buttons="[
              { type: 'reset', label: lang.clear },
              { type: 'submit', label: lang.send }
            ]"
        />
        <ButtonBasic
          class="privacy-policy"
          :label="lang.sentences.emailPolicy"
          @click.native="privacyPolicy"
        />
      </form>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import axios from "axios";
import InputText from "@/components/shared/form/InputText";
import InputTextarea from "@/components/shared/form/InputTextarea";
import ButtonLayout from "@/components/shared/button/ButtonLayout";
import ButtonBasic from "@/components/shared/button/ButtonBasic";

export default {
  name: "PageSlideContact",
  components: { InputText, InputTextarea, ButtonLayout, ButtonBasic },
  props: {
    show: {
      type: Boolean,
      required: true
    }
  },
  data: function() {
    return {
      form: {
        fname: "",
        lname: "",
        email: "",
        message: ""
      }
    };
  },
  methods: {
    ...mapActions("modal", ["openModal"]),
    handleSubmit() {
      let formData = new FormData();
      formData.append("fname", this.form.fname);
      formData.append("lname", this.form.lname);
      formData.append("email", this.form.email);
      formData.append("message", this.form.message);
      this.handleReset();
      this.openModal({
        title: this.lang.sentences.pleaseWait
      });
      axios({
        method: "POST",
        headers: { "content-type": "application/x-www-form-urlencoded" },
        data: formData,
        url: "/services/mail.php"
      })
        .then(response => {
          if (response.data === 1) {
            this.openModal({
              component: "ModalGreenCheck",
              title: this.lang.sentences.emailSent
            });
            return 0;
          }
          return 1;
        })
        .catch(() => {
          return 1;
        })
        .then(error => {
          if (error) {
            this.openModal({
              component: "ModalMessage",
              title: this.lang.sentences.emailErrorTitle,
              message: this.lang.sentences.emailErrorMessage
            });
          }
        });
    },
    handleReset() {
      this.form = {
        fname: "",
        lname: "",
        email: "",
        message: ""
      };
    },
    privacyPolicy() {
      this.openModal({
        component: "ModalPrivacyPolicy",
        title: this.lang.privacy
      });
    }
  },
  computed: {
    ...mapGetters("languages", ["lang"])
  }
};
</script>

<style lang="scss" scoped>
#contact {
  padding-top: $menubar-height + $page-padding-top;
  text-align: center;
}
.contact-form {
  display: inline-block;
  width: $mobile-width;
  max-width: 100%;
  h2 {
    @extend #{$page-title-font-size};
    margin-bottom: $page-title-margin-bottom;
  }
  .container {
    display: flex;
    flex-wrap: wrap;
  }
  .input {
    flex-grow: 1;
    &.small {
      min-width: 300px;
    }
    &.large {
      width: 100%;
    }
  }
}
.button-layout {
  margin-top: $contact-button-layout-margin-top;
}
.privacy-policy {
  @extend #{$contact-privacy-policy-font-size};
  margin: $contact-privacy-policy-margin;
  max-width: $contact-privacy-policy-max-width;
}
</style>
